import { call, put, takeEvery } from 'redux-saga/effects';
import { ACTION_TYPES } from 'src/constants';
import {
  requestCheckoutDetailSuccess,
  requestCheckoutFailure,
  generateCheckoutPaymentFailure,
  generateCheckoutPaymentSuccess,
  generateCheckoutPaymentSipFailure,
  generateCheckoutPaymentSipSuccess,
} from '../actions';

import { getCheckoutDetail, generateCheckoutPayment, generateCheckoutPaymentSip } from '../api';

export function* watchCheckoutRequests() {
  yield takeEvery(ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_REQUEST, requestCheckoutDetail);
  yield takeEvery(ACTION_TYPES.REQUEST_GENERATE_CHECKOUT_PAYMENT, requestGenerateCheckoutPayment);
  yield takeEvery(ACTION_TYPES.REQUEST_GENERATE_CHECKOUT_PAYMENT_SIP, requestGenerateCheckoutPaymentSip);
}

function* requestCheckoutDetail(action) {
  try {
    const checkoutDetail = yield call(getCheckoutDetail, action.payload);
    yield put(requestCheckoutDetailSuccess(checkoutDetail));
  } catch (e) {
    yield put(requestCheckoutFailure(e));
  }
}

function* requestGenerateCheckoutPayment(action) {
  try {
    const payment = yield call(generateCheckoutPayment, action.payload);
    yield put(generateCheckoutPaymentSuccess(payment));
  } catch (e) {
    yield put(generateCheckoutPaymentFailure(e));
  }
}

function* requestGenerateCheckoutPaymentSip(action) {
  try {
    const payment = yield call(generateCheckoutPaymentSip, action.payload);
    yield put(generateCheckoutPaymentSipSuccess(payment));
  } catch (e) {
    yield put(generateCheckoutPaymentSipFailure(e));
  }
}
